import { render, staticRenderFns } from "./CustomerTranslationNewPopup.vue?vue&type=template&id=a0a40a3c&"
import script from "./CustomerTranslationNewPopup.vue?vue&type=script&lang=js&"
export * from "./CustomerTranslationNewPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports